module.exports = __webpack_public_path__ + "media/images/steps_inactive_left_arrow-944c871529c85711924e4c464fae2c84.png";